// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__3Jzjc"};